/*
 * Copyright (c) 2023 by Allen_sun email: Allen_sun_js@hotmail.com, All Rights Reserved.
 */
import axios from "axios";
import { getLoginTocken, getHost } from "@/utils/utils";

const axiosInstance = axios.create({
  baseURL: getHost(),
  timeout: 1600000,
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getLoginTocken();
    token && (config.headers.Authorization = "Bearer " + token);
    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    let resCode = response.data.code;
    if (response.status && resCode == 0) {
      return Promise.resolve(response);
    } else {
      if (resCode == 401) {
        localStorage.clear();
        sessionStorage.clear();
        location.href = "/login";
      }
      return Promise.reject(response);
    }
  },
  (error) => Promise.reject(error.response)
);

export default axiosInstance;
